import { COMMON_STATE } from '@/api/resources/entityState/common-state'
import { EntityState } from '@/api/resources/entityState/entity-state'
import { commonStatusService } from '@/api/services/common/status/common-status.service'
import { EntityStatusState, StoreStateModel } from '@/store/root/root-store.model'
import { keyBy, merge } from 'lodash'
import { store } from '@/store/store'

export const SAMPLE_STATES = {
    DRAFT: { code: 'DRAFT', class: 'state-draft', order: 10 },
    REGISTERED: { code: 'REGISTERED', class: 'state-primary', order: 20 },
    PREPROCESSED: { code: 'PREPROCESSED', class: 'state-process-5', order: 30 },
    IN_PROCESSOR: { code: 'IN_PROCESSOR', class: 'state-process-6', order: 30 },
    PROCESSED: { code: 'PROCESSED', class: 'state-success', order: 40 },
    REPROCESSING_REQUESTED: { code: 'REPROCESSING_REQUESTED', class: 'state-pending', order: 50 },
    ARCHIVED: { code: COMMON_STATE.ARCHIVED, class: 'state-archived', order: 60 },
    DISCARDED: { code: 'DISCARDED', class: 'state-discarded', order: 70 },
    IN_SHIPMENT: { code: 'IN_SHIPMENT', class: 'state-shipment', order: 80 },
    OUT_OF_LABORATORY: { code: 'OUT_OF_LABORATORY', class: 'state-out-of-laboratory', order: 90 }
}

class SampleState extends EntityState {
    protected get entityName(): string {
        return 'sample'
    }

    async loadStates(): Promise<void> {
        if (!this.states.length) {
            const states = await commonStatusService.getSampleStates()
            const entityState: StoreStateModel<EntityStatusState[]> = {
                name: this.entityName,
                state: Object.values(
                    merge(
                        keyBy(states, 'code'),
                        keyBy(SAMPLE_STATES, 'code')))
            }
            await store.dispatch('setEntityState', entityState)
        }
    }
}

export const sampleState = new SampleState()
